import { css, useTheme } from '@emotion/react';
import { Grid2 as Grid } from '@mui/material';
import PropTypes from 'prop-types';
import { ReactComponent as LoadingSpinner } from '../../images/vectors/loading_spinner.svg';

const svgCss = (theme) => css`
  path {
    fill: ${theme.palette.primary.main};
  }
`;

/**
 * Renders a spinner svg which can be used inline or as an overlay
 * @param {Object} props - React props passed to the LoadingOverlay component.
 * @param {string} props.loadingText - React props passed to the LoadingOverlay component.
 * @param {Object} prop.sxProp - passed to sx prop of Grid
 * @returns {React.Component}
 */
export const LoadingOverlay = ({
  loadingText = 'Loading content',
  sxProp = {},
}) => {
  const theme = useTheme();

  return (
    <Grid
      container
      spacing={0}
      align="center"
      justifyContent="center"
      direction="column"
      flexGrow={1}
      aria-live="assertive"
      role="alert"
      height="100%"
      sx={{
        background: 'transparent',
        zIndex: 99,
        ...sxProp,
        width: '100%',
      }}
    >
      <Grid>
        <LoadingSpinner aria-label={loadingText} css={svgCss(theme)} />
      </Grid>
    </Grid>
  );
};

LoadingOverlay.propTypes = {
  loadingText: PropTypes.string,
};
